import { useContext } from 'react'
import { Alert, Stack, Typography, useMediaQuery, useTheme } from '@mui/material'
import { CreateCampaignContext } from '~/contexts/CreateCampaignContext'
import { CampaignCategory } from '~/generated/graphql'
import { staticPath } from '~/lib/$path'
import { CommonStepContent } from './CommonStepContent'
import { LinkToInfo } from '~/components/common/LinkToInfo'
import { EXTERNAL_LINKS } from '~/lib/externalLinks'

export const NoChargeCampaignStep = () => {
  const { campaign } = useContext(CreateCampaignContext)
  const isService = campaign.category === CampaignCategory.Service
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  const imageSrc = isService
    ? isMobile
      ? staticPath.expense_info_steps.service_no_charge_campaign_sp_png
      : staticPath.expense_info_steps.service_no_charge_campaign_pc_png
    : isMobile
      ? staticPath.expense_info_steps.product_no_charge_campaign_sp_png
      : staticPath.expense_info_steps.product_no_charge_campaign_pc_png

  const messages = isService
    ? [
        '無償提供型は、インフルエンサーの来店日時を事前に調整し、当日に店舗がサービスを無償で提供する形式です。',
        'PR投稿後は、インフルエンサーから投稿完了の報告が提出され、確認・承認することで完了となります。',
      ]
    : [
        '無償提供型は、インフルエンサーの住所を確認のうえ、商品を配送していただくことでインフルエンサーへ無償で提供する形式です。',
        'PR投稿後は、インフルエンサーから投稿完了の報告が提出され、確認・承認することで完了となります。',
      ]

  return (
    <CommonStepContent
      imageSrc={imageSrc}
      alt={isService ? 'noChargeCampaignStepServiceImage' : 'noChargeCampaignStepProductImage'}
    >
      <Alert severity="info" icon={isMobile ? false : undefined} sx={{ mb: 2 }}>
        <Stack gap={0.5}>
          <Stack gap={0.5}>
            {messages.map((line, index) => (
              <Typography key={index} variant="body2">
                {line}
                <br />
              </Typography>
            ))}
            <LinkToInfo href={EXTERNAL_LINKS.NO_CHARGE_FAQ} textAfter="をご確認ください。" />
          </Stack>
        </Stack>
      </Alert>
    </CommonStepContent>
  )
}
